import { Navigate, useLocation } from 'react-router-dom';

import { routePaths } from 'global/routePaths';
import { useParamsQuery } from 'hooks/common/useParamsQuery';
import tokenService from 'utils/token';

import PaylocityGuestForm from './PaylocityIntegrationForm';

const PaylocityIntegrationRequest = () => {
  const search = useLocation().search;

  const searchQuery = useParamsQuery();

  const paylocityCompanyId = searchQuery.get('paylocityCompanyId');

  if (!tokenService.getAccessToken() || tokenService.getAccessToken() === 'undefined') {
    return <PaylocityGuestForm paylocityCompanyId={paylocityCompanyId} />;
  } else {
    return <Navigate replace to={`${routePaths.integrations.newPaylocity.base}${search}`} />;
  }
};

export default PaylocityIntegrationRequest;
